import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
//primereact
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
//components
import Toggle from "../../../../components/button/Toggle";
import { postAmortization } from "../../../../services/Settings/Simulator/postAmortization";
import { useMutation } from "react-query";
import { queryClient } from "../../../../utils/queryClient";
import { Button } from "primereact/button";
import Cookies from "js-cookie";
import { useSetState } from "react-use";
import { logGroup, translatedButtons } from "../../../../utils/joyHelpers";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { getUserId } from "../../../../utils/auth";

export default function Amortization({ info, loading, refetch }) {
  const { id } = useParams();
  const form = useForm();
  const errors = form.formState.errors;
  const [types, setTypes] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [amortization, setAmortization] = useState({
    price: false,
    sac: false,
    sac_inverso: false,
    sacre: false,
    sacre_ib: false,
    sacoc: false,
    interest_free: false,
  });

  const userId = getUserId();

  const { mutateAsync: postAmortizationFn, isLoading } = useMutation({
    mutationFn: postAmortization,
    onSuccess(_, variables) {
      queryClient.setQueryData([`dataAmortization${id}`], (data) => {
        data[0] = {
          id: variables.enterprise_id,
          type: variables.type,
          price: variables.price ? 1 : 0,
          sac: variables.sac ? 1 : 0,
          sac_inverso: variables.sac_inverso ? 1 : 0,
          sacre: variables.sacre ? 1 : 0,
          sacre_ib: variables.sacre_ib ? 1 : 0,
          sacoc: variables.sacoc ? 1 : 0,
          interest_free: variables.interest_free ? 1 : 0,
        };
        return [...data];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const handleEditAmortization = (name, value) => {
    if (name === "price") {
      form.setValue("financing", true);
    }
    setAmortization((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = async () => {
    setLoadingButton(true);
    const data = {
      enterprise_id: parseInt(id),
      data: [],
    };
    types.forEach((item) => {
      if (item === "financing") {
        data.data.push({ type: item, ...amortization });
      } else {
        data.data.push({
          type: item,
          price: 1,
        });
      }
    });
    const notification = toast.loading("Por favor aguarde...");

    const response = await postAmortizationFn(data);

    if (response.success) {
      refetch().then(() => {
        toast.update(notification, {
          render: "Sistema de amortização editado com sucesso",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
        setLoadingButton(false);
      });
      return;
    } else {
      toast.update(notification, {
        render: "Ocorreu algum erro a editar!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
  };

  const onSubmitConfig = async (name) => {
    let type = [];
    type = [...types, name];
    if (types.includes(name)) {
      type = type.filter((item) => item !== name);
    }
    setTypes(type);
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    if (info) {
      let type = [];
      // console.log(info)
      const defaultValues = {};
      info.map((item) => {
        if (item.type === "entry") {
          defaultValues.entry = true;
        }
        if (item.type === "construction") {
          defaultValues.construction = true;
        }
        if (item.type === "intermediate") {
          defaultValues.intermediate = true;
        }
        if (item.type === "financing") {
          defaultValues.financing = true;
          defaultValues.price = item.price === 1;
          defaultValues.sac = item.sac === 1;
          defaultValues.sac_inverso = item.sac_inverso === 1;
          defaultValues.sacre = item.sacre === 1;
          defaultValues.sacre_ib = item.sacre_ib === 1;
          defaultValues.sacoc = item.sacoc === 1;
          defaultValues.interest_free = item.interest_free === 1;
          setAmortization({
            price: item.price === 1,
            sac: item.sac === 1,
            sac_inverso: item.sac_inverso === 1,
            sacre: item.sacre === 1,
            sacre_ib: item.sacre_ib === 1,
            sacoc: item.sacoc === 1,
            interest_free: item.interest_free === 1,
          });
        }
        type.push(item.type);
      });
      setTypes(type.length === 0 ? ["financing"] : type);
      form.reset(defaultValues);
    }
  }, [info]);

  const [{ run, stepIndex, steps }, setState] = useSetState({
    run: false,
    stepIndex: 0,
    steps: [],
  });

  useEffect(() => {
    const hasSeenTour = Cookies.get(`hasSeenSimConfigAmortization_${userId}`);
    if (!isLoading && !loading && !hasSeenTour) {
      setState({
        run: true,
        steps: [
          {
            content: (
              <>
                <h2>Sistemas de Amortização para Financiamento</h2>
                <p className="mb-0">
                  Selecione os sistemas que deseja utilizar no seu financiamento
                  lembrando que na própria simulação você pode alterar a tabela
                  de amortização caso ela esteja previamente configurada aqui.
                </p>
              </>
            ),
            target: ".financing-tables",
            disableBeacon: true,
          },
          {
            content: (
              <>
                <h2>Escolha onde usar a Price</h2>
                <p className="mb-0">
                  Você pode escolher utilizar a tabela PRICE em outras etapas da
                  simulação, basta clicar sobre a etapa e pronto.
                </p>
              </>
            ),
            target: ".other-tables",
            disableBeacon: true,
          },
          {
            content: (
              <>
                <h2>Salve suas Alterações</h2>
                <p className="mb-0">
                  Não se esqueça de salvar a suas alterações.
                </p>
              </>
            ),
            target: ".save-btn",
            disableBeacon: true,
          },
        ],
      });
    }
  }, [isLoading, loading]);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    //    console.log(data);
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      Cookies.set(`hasSeenSimConfigAmortization_${userId}`, "true");
      setState({ run: false, stepIndex: 0 });
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      setState({
        stepIndex: nextStepIndex,
      });
    }

    logGroup(type === EVENTS.TOUR_STATUS ? `${type}:${status}` : type, data);
  };

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={run}
        scrollToFirstStep
        showProgress
        showSkipButton
        stepIndex={stepIndex}
        locale={translatedButtons}
        steps={steps}
        styles={{
          options: {
            primaryColor: "#00b9a7",
            buttonNext: {
              color: "#FFFFFF",
            },
            buttonPrev: {
              color: "#FFFFFF",
            },
          },
        }}
      />
      {loading && (
        <div className="row">
          <div className="col-md-6 my-3">
            <div className="pb-3">
              <h3>
                {" "}
                Selecione onde usar o sistema de amortização{" "}
                <Tooltip target=".custom-target" position="top" />
                <i
                  className="custom-target pi pi-question-circle p-text-secondary"
                  data-pr-tooltip="Selecione em quais etapas da venda deseja aplicar o juros de acordo com as tabelas de amortização."
                  style={{ cursor: "pointer" }}
                ></i>
              </h3>
            </div>
            <div className="row">
              <Skeleton width="100%" height="120px"></Skeleton>
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <div className="d-flex">
              <h3 className="pb-3">
                {" "}
                Selecione onde usar o sistema de amortização{" "}
                <Tooltip target=".custom-target" position="top" />
                <i
                  className="custom-target pi pi-question-circle p-text-secondary"
                  data-pr-tooltip="Escolha qual sistema de amortização você irá utilizar"
                  style={{ cursor: "pointer" }}
                ></i>
              </h3>
            </div>
            <div className="row">
              <Skeleton width="100%" height="150px"></Skeleton>
            </div>
          </div>
          <hr className="my-4" />
          <div className="col-md-12 d-flex">
            <Skeleton width="10%" height="50px"></Skeleton>
          </div>
        </div>
      )}

      {!loading && (
        <>
          <form>
            <div className="row">
              <div className="col-md-12 mt-3 financing-tables">
                <div className="d-flex">
                  <h3 className="pb-3">
                    {" "}
                    Selecione os sistemas de amortização{" "}
                    <Tooltip target=".custom-target" position="top" />
                    <i
                      className="custom-target pi pi-question-circle p-text-secondary"
                      data-pr-tooltip="Escolha qual sistema de amortização você irá utilizar"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h3>
                </div>
                <div className="row">
                  <div className="col-xl-2 col-md-6 my-3 form-group">
                    <Toggle
                      name="price"
                      onChange={(e) => handleEditAmortization("price", e)}
                      onLabel="Price"
                      offLabel="Price"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-2 col-md-6 mx-auto my-3 form-group">
                    <Toggle
                      name="sac"
                      onChange={(e) => handleEditAmortization("sac", e)}
                      onLabel="SAC"
                      offLabel="SAC"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-3 col-md-6 mx-auto my-3 form-group">
                    <Toggle
                      name="sac_inverso"
                      onChange={(e) => handleEditAmortization("sac_inverso", e)}
                      onLabel="SAC Invertido"
                      offLabel="SAC Invertido"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  {/* <div className="col-xl-2 col-md-6 mx-auto my-3 form-group">
                    <Toggle
                      name="sacre"
                      onChange={(e) => handleEditAmortization("sacre", e)}
                      onLabel="SACRE"
                      offLabel="SACRE"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-2 col-md-6 my-3 form-group">
                    <Toggle
                      name="sacre_ib"
                      onChange={(e) => handleEditAmortization("sacre_ib", e)}
                      onLabel="SACRE IB"
                      offLabel="SACRE IB"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div> */}

                  <div className="col-xl-2 col-md-6 my-3 form-group">
                    <Toggle
                      name="sacoc"
                      onChange={(e) => handleEditAmortization("sacoc", e)}
                      onLabel="SACOC"
                      offLabel="SACOC"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-2 col-md-6 my-3 form-group">
                    <Toggle
                      name="interest_free"
                      onChange={(e) =>
                        handleEditAmortization("interest_free", e)
                      }
                      onLabel="Sem Juros"
                      offLabel="Sem Juros"
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-md-1"></div>
                </div>
              </div>
              <div
                className={`col-xl-8 my-3 other-tables justify-content-end ${
                  !form.getValues("price") && "d-none"
                }`}
              >
                <div className="pb-3">
                  <h3>
                    {" "}
                    Selecione onde usar o sistema de amortização Price{" "}
                    <Tooltip target=".custom-target" position="top" />
                    <i
                      className="custom-target pi pi-question-circle p-text-secondary"
                      data-pr-tooltip="Selecione em quais etapas da venda deseja aplicar o juros de acordo com a tabela Price."
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h3>
                </div>
                <div className="row">
                  <div className="col-xl-4 col-md-6">
                    <Toggle
                      name="entry"
                      onLabel="Entrada"
                      offLabel="Entrada"
                      onChange={(e) => onSubmitConfig("entry")}
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-4 col-md-6">
                    <Toggle
                      name="financing"
                      onLabel="Financiamento"
                      offLabel="Financiamento"
                      preValue={true}
                      // onChange={(e) => onSubmitConfig("financing")}
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                      disabled={true}
                    />
                  </div>
                  <div className="col-xl-4 col-md-6">
                    <Toggle
                      name="construction"
                      onLabel="Parcela de Obra"
                      offLabel="Parcela de Obra"
                      onChange={(e) => onSubmitConfig("construction")}
                      control={form.control}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end pt-2">
                <Button
                  rounded
                  iconPos="right"
                  label="Salvar"
                  loading={loadingButton}
                  onClick={() => onSubmit()}
                  icon="fa-solid fa-check"
                  className="p-inputtext-sm save-btn"
                />
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
}
